export const marketClosed = (closed: boolean) =>
  ({ type: 'market.marketClosed', payload: { closed } } as const)
export type MarketClosedAction = ReturnType<typeof marketClosed>

export const marketCloseTimerTick = () =>
  ({ type: 'market.closeTimerTick' } as const)
export type MarketCloseTimerTickAction = ReturnType<typeof marketCloseTimerTick>

export type MarketAction = MarketClosedAction | MarketCloseTimerTickAction
